import { useEssentials } from 'hooks/utils/useEssentials'
import { isStore } from 'utils/location'
import { StoreFulfillmentNddStore } from './store-fulfillment-ndd-store'
import { StoreFulfillmentNddRGD } from './store-fulfillment-ndd-rgd'

export const StoreFulfillmentNdd = () => {
    const { currentLocation } = useEssentials()
    if (isStore(currentLocation)) {
        return <StoreFulfillmentNddStore />
    } else {
        return <StoreFulfillmentNddRGD />
    }
}
